import React, { useState } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { Search } from '@mui/icons-material';
import { styled } from '@mui/system';
import { CountCustomerProduct } from '../types/customerProduct';
import { colors } from '../../utils/theme';

const CustomTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    borderRadius: 20,
    height: '45px',
    backgroundColor: colors.backGroundColor,
  },
});

interface SearchTextProps {
  products: CountCustomerProduct[];
  setUpdatedProducts: (updatedProducts: CountCustomerProduct[]) => void;
}

const SearchText = ({ products, setUpdatedProducts }: SearchTextProps) => {
  const [searchTerm, setSearchTerm] = useState<string>('');

  const handleSearch = (event: any) => {
    const keyword = event.target.value;
    setSearchTerm(keyword);

    const filtered = products.map(product => ({
      ...product,
      is_display: keyword === "" || product.product_keyword.includes(keyword)
    }));

    setUpdatedProducts(filtered);
  };

  return (
    <CustomTextField
      variant="outlined"
      placeholder="キーワードで検索"
      value={searchTerm}
      onChange={handleSearch}
      sx={{ 
        flex: 1, 
        mr: 1,
        zIndex: 1,
        position: "fixed",
        top: '105px',
        width: '90%',
        padding: '8px',
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchText;
